import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import database from "./models";
import app from "./modules/app";
import firebase from 'firebase/app';
import 'firebase/auth';
var firebaseConfig = {
  apiKey: 'AIzaSyChpx9sa4svZ9lhx6a_e977YWGciwatNfE',
  authDomain: 'timeneye-web.firebaseapp.com',
  databaseURL: 'https://timeneye-web.firebaseio.com',
  projectId: 'timeneye-web',
  storageBucket: 'timeneye-web.appspot.com',
  messagingSenderId: '410389300352',
  appId: '1:410389300352:web:200f1fe684382dddc09265'
};
firebase.initializeApp(firebaseConfig);
VuexORM.use(VuexORMAxios, {
  dataTransformer: function dataTransformer(response) {
    if (typeof response.data !== 'undefined') {
      if (typeof response.data.data !== 'undefined') {
        return response.data.data;
      }

      return response.data;
    }

    return response;
  }
});
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function ()
/* { ssrContext } */
{
  var store = new Vuex.Store({
    namespaced: true,
    plugins: [VuexORM.install(database)],
    modules: {
      app: app
    }
  });
  return store;
}